import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Category} from "../../models/category.model";
import {CategorySelectMenuComponent} from "../category-select-menu/category-select-menu.component";
import {PopoverController} from "@ionic/angular";

@Component({
  selector: 'app-category-picker',
  templateUrl: './category-picker.component.html',
  styleUrls: ['./category-picker.component.scss'],
})
export class CategoryPickerComponent implements OnInit {

  @Input() categoriesMap: Map<number, Category[]>;

  @Input() category: Category;
  @Input() disabled: boolean;

  @Output() categoryEmitter = new EventEmitter<Category>();
  @Output() cancelEmit = new EventEmitter<boolean>();

  keys: number[] = [];

  categoriesSelected: Map<number, Category> = new Map<number, Category>();


  constructor(private popoverController: PopoverController) {
  }

  ngOnInit() {
    this.categoriesMap.forEach((val, key) => {
      this.keys.push(key)
    })
  }

  getKeys() {
    return this.keys;
  }

  getSelected(i: number) {
    let res = this.categoriesSelected.get(i);
    if (res) {
      return res;
    } else {
      return null;
    }
  }

  cancel() {
    this.cancelEmit.emit(true);
  }

  async openSelectCategoryMenu(i) {
    const popover = await this.popoverController.create({
        component: CategorySelectMenuComponent,
        componentProps: {
          'categories': this.categoriesMap.get(i).filter(e => {
            if (i > this.category?.level) {
              return e.parentUUID === this.category.uuid;
            } else {
              return true;
            }
          }),
        },
        translucent: true
    });

    await popover.present();

    await popover.onDidDismiss().then(e => {
      if (e && e.data) {
        this.category = e.data;
        this.categoryEmitter.emit(this.category);
      }
    });
  }

  getNameOfSubCategory(i) {
    if (this.category) {
      let level = this.category.level;
      if (this.category.parentUUID) {
        if (level === i) {
          return this.category.name;
        } else {
          if (level < i) {
            return '-';
          } else {
            let cat = this.category;
            for (let j = this.category.level; j > i; j--) {
              cat = this.getParentCat(j, cat.parentUUID);
            }
            return cat.name;
          }
        }
      } else {
        if (level < i) {
          return '-';
        } else {
          return this.category.name;
        }
      }
    } else {
      return '-';
    }
  }

  canBeChoosen(i: any) {
    if (this.category) {
      if (i <= this.category.level + 1) {
        return true;
      } else {
        return false;
      }
    } else {
      if (i === 0) {
        return true;
      } else {
        return false;
      }
    }

  }

  private getParentCat(i: any, parentUUID: string) {
    return this.categoriesMap.get(i - 1).filter(e => e.uuid === parentUUID)[0];
  }
}
